var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VApp',[_c('ThePageHeader'),_c('VContent',{staticClass:"pa-0 container"},[_c('VContainer',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('transition',{attrs:{"appear":"","name":"appear","mode":"out-in"}},[_c('router-view')],1)],1)],1),_c('ThePageFooter'),_c('TheCookieBar'),_c('ThePageFbChat')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }